import { PDF_LAYOUT } from 'pages/reporting/shared/pdfGeneration/constants/layout'
import { PDF_TYPOGRAPHY } from 'pages/reporting/shared/pdfGeneration/constants/typography'

/**
 * FFS Report Page Style
 * Matches the rooftop report pattern with explicit page sizing and padding
 * to prevent page truncation and ensure consistent rendering
 */
export const ffsPageStyle = {
  padding: `${PDF_LAYOUT.PADDING.PAGE}px ${PDF_LAYOUT.PADDING.PAGE}px 50px ${PDF_LAYOUT.PADDING.PAGE}px`,
  fontSize: PDF_TYPOGRAPHY.FONT_SIZE.MEDIUM,
  fontFamily: PDF_TYPOGRAPHY.FONT_FAMILY.PRIMARY,
}
